import { ValidatorFn, AbstractControl } from '@angular/forms';
import { ValidTypeList } from './ValidTypeList';

const CommaNumber =  ValidTypeList.PositiveFloatOptionalComma;
export function CommaNumberValidator(): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} | null => {
    const isValid = CommaNumber.test(control.value);
    return isValid ? null : {IncorrectFormatNumber: {value: control.value}}  ;
  };
}

